define('glu/datePicker',['require','./datepicker/datePicker'],function(require) {
    'use strict';

    return require('./datepicker/datePicker');
});

